module.exports = __webpack_public_path__ + "img/115.4b669337.jpg";